import React, { StrictMode } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <Router basename="/"> // 👈 Coloca el Router aquí con el basename
      <App />
    </Router>
  </StrictMode>
);

/*
const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);*/